import React from 'react';

const ConditionalRender = React.memo((props) => {
    //if (props.children[0]?.props.__TYPE && props.visible) {
    //    props.__TYPE = props.children[0]?.props.__TYPE;
    //}
    return props.visible ? props.children : null
});

export default ConditionalRender